import React from "react";
import { SortingChips } from "../../../../Components/SortingChips/SortingChips";
import { SortItemType } from "../../../../Components/SortingChips/SortingChips.types";
import { setLocalSelectedPostSortOption } from "@infrastructure/Persistence/LocalUserStorage";
import { SORT_CRITERIA_LIST } from "@shared/consts";

export function PostsSortingChips({
    selectedSortCriteria,
    setSelectedSortCriteria,
}: {
    selectedSortCriteria: SortItemType;
    setSelectedSortCriteria: (sortCriteria: SortItemType) => void;
}) {
    const onPostsFiltersSelectChange = (sortItem: SortItemType) => {
        const index = SORT_CRITERIA_LIST.indexOf(sortItem);
        setLocalSelectedPostSortOption(index);
        setSelectedSortCriteria(SORT_CRITERIA_LIST[index]);
    };

    return (
        <SortingChips
            onChange={onPostsFiltersSelectChange}
            selectedIndex={SORT_CRITERIA_LIST.indexOf(selectedSortCriteria)}
        />
    );
}
